<template>
  <div style="overflow-y: scroll;" id="innerAg" class="flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 ">
      <vs-prompt
        id="widerPopup"
        name="selectProductsPopup"
        vs-title="Ürün listesi"
        vs-accept-text="Ekle"
        vs-cancel-text="Vazgeç"
        vs-button-cancel="border"
        @vs-cancel="closeFields"
        @vs-accept="saveSelectedProducts"
        @vs-close="closeFields"
        :vs-active.sync="openProductPopup"
      >
        <div>
          <ag-grid-vue
            @row-selected="onRowSelected"
            @cellValueChanged="onCellValueChanged"
            :gridOptions="gridOptions"
            class="ag-theme-material ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :suppressRowClickSelection="true"
            rowDataChangeDetectionStrategy="IdentityCheck"
          ></ag-grid-vue>
          <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
        </div>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { repository } from "@/_services/repository.js";

import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
  components: {
    AgGridVue,
  },
  props: {
    openProducts: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      taxIncluded: true,
      temporary: [],
      gridOptions: {
        pagination: true,
        rowHeight: 40,
        headerHeight: 40,
        autoGroupColumnDef: {
          headerName: " row groups! ",
        },
      },
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true,
      },

      columnDefs: [
        {
          field: "productId",
          hide: true,
        },
        // {
        //   headerName: "",
        //   checkboxSelection: true,
        //   width: 55,
        //   editable: false,
        // },
        {
          checkboxSelection: true,
          headerName: "Kategori",
          field: "productCategory",
          width: 100,
          filter: true,
          editable: false,
          cellRenderer: (params) => {
            return params.value.length > 25 ? '<span title="' + params.value + '">' + params.value + "</span>" : params.value;
          },
        },
        {
          headerName: "Ürün",
          field: "productName",
          width: 250,
          filter: true,
          editable: false,
          cellRenderer: (params) => {
            return params.value.length > 25 ? '<span title="' + params.value + '">' + params.value + "</span>" : params.value;
          },
        },
        {
          headerName: "Stok",
          field: "stock",
          width: 75,
          editable: false,
        },
        {
          headerName: "Depo",
          field: "wareHouse",
          width: 125,
          filter: true,
          editable: false,
          cellRenderer: (params) => {
            if (params.value) return '<span title="' + params.value + '">' + params.value + "</span>";
            else return '<span title="stok yok">stok yok</span>';
          },
        },
        {
          headerName: "Birim Fiyatı",
          field: "salePrice",
          filter: "agNumberColumnFilter",
          width: 80,
          editable: false,
        },
        {
          headerName: "Tür",
          field: "salePriceCurrencyName",
          width: 70,
          editable: false,
        },
        {
          headerName: "Satış Fiyatı",
          field: "sellPrice",
          filter: "agNumberColumnFilter",
          width: 100,
          editable: true,
        },
        {
          headerName: "Adet",
          field: "quantity",
          filter: "agNumberColumnFilter",
          width: 80,
          editable: true,
          cellRenderer: (data) => {
            if (data.value == undefined) data.value = 1;
            return data.value;
          },
        },
      ],
      productDataForAggrid: [],
    };
  },
  computed: {
    openProductPopup: {
      get() {
        return this.openProducts;
      },
      set() {},
    },
    paginationPageSize() {
      return 20;
    },

    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    //agden seçilen ürünleri kaydedeceğiz
    saveSelectedProducts() {
      this.gridApi.stopEditing();
      let rows = this.gridOptions.api.getSelectedRows();
      this.temporary.splice(0, this.temporary.length);
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].sellPrice == 0) {
          this.$vs.notify({
            title: "Hata",
            text: "Hatalı satış fiyatı",
            color: "danger",
            icon: "warning",
          });
          return;
        }
        let pr = (rows[i].sellPrice && rows[i].sellPrice.toString().replace(/,/g, ".")) || rows[i].price.toString(/,/g, ".");
        if (isNaN(parseFloat(pr))) {
          this.$vs.notify({
            title: "Hata",
            text: "Hatalı satış fiyatı",
            color: "danger",
            icon: "warning",
          });
          return;
        }
        rows[i].sellPrice = parseFloat(pr);
        rows[i].price = rows[i].price || rows[i].sellPrice;
        let qty = (rows[i].quantity && rows[i].quantity.toString()) || "1";
        if (isNaN(parseInt(qty))) {
          this.$vs.notify({
            title: "Hata",
            text: "Hatalı miktar",
            color: "danger",
            icon: "warning",
          });
          return;
        }
        rows[i].quantity = parseInt(qty);
        this.temporary.push(rows[i]);
      }
      this.$emit("hideProducts", 1, [].concat(this.temporary));
    },

    closeFields() {
      this.$emit("hideProducts", 0);
    },
    onCellValueChanged(dataGridProperties) {
      if (dataGridProperties.oldValue == dataGridProperties.newValue) return;
      let query = "div[row-id='" + (dataGridProperties.data.wareHouseId && dataGridProperties.data.wareHouseId.toString()) + "_" + dataGridProperties.data.productId.toString() + "'] div[col-id='" + dataGridProperties.colDef.field + "']";
      let row = document.querySelector(query);
      if (dataGridProperties.newValue == "" && dataGridProperties.node.selected) {
        row.innerText = dataGridProperties.oldValue;
        dataGridProperties.data[dataGridProperties.colDef.field] = dataGridProperties.oldValue;
        dataGridProperties.node.data[dataGridProperties.colDef.field] = dataGridProperties.oldValue;
        return;
      }
      let checkIsNumber = parseFloat(dataGridProperties.value.replace(/,/g, "."));
      if (!isNaN(checkIsNumber)) {
        dataGridProperties.data[dataGridProperties.colDef.field] = checkIsNumber;
        dataGridProperties.node.data[dataGridProperties.colDef.field] = checkIsNumber;
        dataGridProperties.node.setSelected(true);
      } else {
        row.innerText = "";
        dataGridProperties.data[dataGridProperties.colDef.field] = dataGridProperties.oldValue;
        dataGridProperties.node.data[dataGridProperties.colDef.field] = dataGridProperties.oldValue;
        this.$vs.notify({
          title: "Hata",
          text: "Hatalı " + dataGridProperties.colDef.headerName,
          color: "danger",
          icon: "warning",
        });
      }
    },
    onRowSelected(event) {
      if (event.node.data.quantity === undefined) event.node.data.quantity = 1;
      if (event.node.data.sellPrice === undefined) event.node.data.sellPrice = event.node.data.price;
      let q1 = "div[row-id='" + (event.data.wareHouseId && event.data.wareHouseId.toString()) + "_" + event.data.productId + "'] div[col-id='sellPrice']";
      let q2 = "div[row-id='" + (event.data.wareHouseId && event.data.wareHouseId.toString()) + "_" + event.data.productId + "'] div[col-id='quantity']";
      let price = document.querySelector(q1);
      let quantity = document.querySelector(q2);
      price.innerText = event.node.data.sellPrice;
      quantity.innerText = event.node.data.quantity;
    },
    setSelectedItems(api) {
      if (this.productDataForAggrid.length == api.getDisplayedRowCount()) {
        for (let i = 0; i < this.temporary.length; i++) {
          let query = (this.temporary[i].wareHouseId && this.temporary[i].wareHouseId.toString()) + "_" + this.temporary[i].productId;
          let node = api.getRowNode(query);
          if (node) {
            node.setSelected(true);
          }
        }
        this.gridApi.sizeColumnsToFit();
        clearInterval(window.watcher);
        window.watcher = 0;
      }
    },
    //ürünleri çekiyoruz ve çekerken de önceden seçilmiş olanlar (value) ile çekilenleri karşılaştırıp tikleyip en üstte gösteriyoruz
    getProducts: async function() {
      let data = await repository.getAll("Product/getProductsV1").then((r) => r.list);
      this.temporary = [].concat(this.value);
      if (Array.isArray(this.temporary) && this.temporary.length > 0) this.taxIncluded = !!this.temporary[0].taxIncluded;
      for (let i = 0; i < this.temporary.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (this.temporary[i].productId == data[j].productId && this.temporary[i].wareHouseId == data[j].wareHouseId) {
            let x = Object.assign({}, this.temporary[i]);
            x.wareHouse = data[j].wareHouse;
            data.splice(j, 1)[0];
            x.sellPrice = this.taxIncluded ? x.priceWithTaxes || x.sellPrice : x.priceDiscounted;
            data.unshift(x);
            break;
          }
        }
      }
      this.productDataForAggrid = data;
      this.gridApi.setRowData(this.productDataForAggrid);
      window.watcher = setInterval(this.setSelectedItems, 50, this.gridApi);
    },
  },
  created() {
    this.getProducts();
  },
  mounted() {
    this.gridOptions.getRowNodeId = function(data) {
      return (data.wareHouseId && data.wareHouseId.toString()) + "_" + data.productId.toString();
    };
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
};
</script>

<style>
/* #innerAg {
  .con-vs-dialog .vs-dialog {
    max-width: 80% !important;
    overflow-y: scroll !important;
  } */
@media screen and (max-width: 575px) {
  .ag-theme-material .ag-cell {
    padding-left: 0px !important;
    padding-right: 0px !important;
    font-size: 10px !important;
  }
}
</style>
